import { VisuallyHidden } from "@99tech/ui";
import { Box } from "@mui/material";
import React, { MouseEvent, useCallback, useContext } from "react";
import { Apps, Chars, LoginButtonImage, Logo, RegisterButtonImage } from "src/assets";
import { AppContext } from "src/main/constants";
import useGtmTracker, { EvtAction } from "src/main/hooks/useGtmTracker";
import { createStyles, isMobile } from "src/main/utils";

interface LandingPageProps extends React.PropsWithChildren {}

const LandingPage: React.FC<LandingPageProps> = (props) => {
  const { sendEvent } = useGtmTracker();
  const { urls } = useContext(AppContext);
  const { loginUrl, registerUrl } = urls ?? {};

  const handleClick = useCallback(
    (type: "login" | "register") => (e: MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      if (type === "login") {
        sendEvent(EvtAction.ClickLogin);
        window.open(loginUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      } else {
        sendEvent(EvtAction.ClickRegister);
        window.open(registerUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      }
    },
    [loginUrl, registerUrl, sendEvent],
  );

  return (
    <Box sx={styles.root}>
      <VisuallyHidden as="h1">Gig58</VisuallyHidden>

      <img
        alt="GIG88"
        src={Logo}
        width={300}
        style={{ marginTop: "4px" }}
      />

      <Box sx={styles.buttons}>
        <a
          href={loginUrl}
          onClick={handleClick("login")}
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={LoginButtonImage}
            alt="login"
            height={52}
            style={{ marginRight: "-4px" }}
          />
        </a>
        <a
          href={registerUrl}
          onClick={handleClick("register")}
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={RegisterButtonImage}
            alt="register"
            height={64}
            style={{ marginLeft: "-4px" }}
          />
        </a>
      </Box>

      <img
        src={Chars}
        alt="chars"
        style={{
          marginTop: "-80px",
        }}
        width={360}
      />

      <img
        src={Apps}
        alt="apps"
        style={{
          marginTop: "12px",
        }}
        width={190}
      />
    </Box>
  );
};

const styles = createStyles({
  root: {
    pt: "28px",
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflowX: "auto",
    overflowY: "auto",
    minHeight: "100vh",
    width: "100%",
    color: "white",
  },
  images: {
    zIndex: 10,
    position: "relative",
    width: "360px",
    height: "380px",
    img: {
      position: "absolute",
    },
  },
  buttons: {
    zIndex: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "18px",
    padding: "0px 20px",
    a: {
      // width: "50%",
      cursor: "pointer",
    },
  },
  footer: {
    zIndex: 0,
    position: "fixed",
    bottom: "0",
    width: "100vw",
    height: "200px",
    flexShrink: 0,
  },
  hightlight: {
    background: "linear-gradient(180deg, #D37E00 1%, #FEDE79 35%, #D37E00 68.5%, #FDD65A 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  title: {
    fontSize: "40px",
    fontWeight: 800,
    textAlign: "center",
    lineHeight: "1.1",
  },
  title2: {
    fontSize: "22px",
    fontWeight: 600,
    textAlign: "center",
    lineHeight: "1.3",
  },
  text: {
    fontSize: "8px",
    fontWeight: 700,
    lineHeight: "1.3",
  },
});

export default LandingPage;
